/* eslint-disable max-len */
import React from 'react';
import { IconProps } from '../IconProps';
import { SVGWrapper } from '../SVGWrapper';

const DocumentsNavigationIcon: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style}>
        <path
            d="M20.9,1.7C20.9,1.7,20.9,1.7,20.9,1.7l-14.4,0c-1.5,0-2.7,1.2-2.7,2.7v13.8H1V20c0,1.3,1.1,2.3,2.3,2.3
	c0,0,13.5,0,13.8,0c1.2,0,2.1-1.1,2.1-2.3V8.2h4.1V4C23.3,2.7,22.2,1.7,20.9,1.7z"
        />
        <path d="M3.9,18.1h10.6v1.4c0,0.7,0.2,2.4,1.2,2.8" />
        <path d="M19.1,8.2V3.4c0-1,0.8-1.8,1.8-1.8" />
        <line x1="7.1" y1="14" x2="16" y2="14" />
        <line x1="7.1" y1="10.2" x2="16" y2="10.2" />
        <line x1="7.1" y1="6.5" x2="16" y2="6.5" />
    </SVGWrapper>
);

export default DocumentsNavigationIcon;
